module.exports = __webpack_public_path__ + "img/vertical_3_6_3.9db3422f.png";